import { useCallback, useEffect, useRef } from "react";
import { getDockBodyHost, setDockBodyHost, setDockAvailable, setDockColumnExpanded, setDockHostPage } from "../lib/dockStore.js";
import { useTraceCanvasOpen } from "../lib/traceCanvasStore.js";

export default function ChatHomePage({ chatActive = true }) {
    const workspaceOpen = !!useTraceCanvasOpen();
    const host = useRef(null);
    const hostRef = useCallback((el) => {
        if (el) {
            host.current = el;
            setDockBodyHost(el);
        } else {
            if (host.current && getDockBodyHost() === host.current) setDockBodyHost(null);
            host.current = null;
        }
    }, []);
    useEffect(() => {
        if (workspaceOpen) return undefined;
        setDockAvailable(true);
        setDockHostPage(true);
        setDockColumnExpanded(true);
        if (host.current) setDockBodyHost(host.current);
        return () => {
            setDockAvailable(false);
            setDockHostPage(false);
            setDockColumnExpanded(false);
        };
    }, [workspaceOpen]);
    return <div ref={hostRef} className="flex h-full min-h-0 min-w-0 flex-col" style={{ visibility: chatActive ? undefined : "hidden" }} />;
}
